import { filterLocation } from '@/helpers'
import store from '@/store'

export default {
  props: {
    /** from the publications API. */
    details: Object,
    /** from assigned key */
    index: Number,
    /** from PublicationsPage */
    userPublication: Boolean,
    /** from PublicationsPage */
    isCommerce: Boolean
  },

  data: () => ({
    iconTypes: {
      'GLD': 'sell/gold-a.png',
      'SLVR': 'sell/silver-a.png'
    }
  }),

  computed: {

    /**
     * @return {string} publications' title.
     */
    title () { return this.details.title || '' },

    /**
     * @return {boolean} whether change image
     */
    isRotating () { return this.hls && this.hls.rotating_images },

    /**
     * @return {array[object]} url & order.
     */
    media () { return this.details.media || [] },

    /**
     * @return {array[string]} sorted array of urls.
     */
    images () { return this.media.length > 0 && this.media.map(item => item.image_file_name) },

    image () { return this.media.length > 0 && this.media[0].image_file_name },

    /**
     * @return {object} active/text/color of the band.
     */
    band () {
      const hlb = this.details && this.details.highlight && this.details.highlight.highlight_band
      return {
        active: !!hlb,
        text: hlb ? hlb.text : null,
        color: hlb ? hlb.color : '#000000'
      }
    },

    bandWide () { return this.hls && this.hls.highlight_band },

    hls () { return this.details.highlight },

    city () {
      const pub = this.details
      return pub && pub.geopoint && filterLocation(pub.geopoint.city) || '**Sin ubicación**'
    },

    noPhoto () { return this.$CDN_STATIC + '/static/img/no-photo.png' },

    date () { return this.details.date },

    isHome () {
      const hl_types = this.hls && this.hls.highlight_types
      const home = hl_types && Array.isArray(hl_types) && hl_types.filter(h => h.code !== 'RTI' && h.code !== 'GLD' && h.code !== 'SLVR')
      return !!home && home.length > 0
    },

    icon () {
      const hl_types = this.hls && this.hls.highlight_types
      const icon = hl_types && Array.isArray(hl_types) && hl_types.filter(h => h.code !== 'RTI' && h.code !== 'HM')
      return icon && icon[0] && this.iconTypes[icon[0].code] || null
    },

    iconSrc () { return this.icon && this.$CDN_STATIC + '/static/icons/' + this.icon },

    urlCategory () {
      let catArray = this.details.category_path
      let url = ''

      catArray && catArray.map(catObj => {
        url = url + ' / ' + catObj.name
      })

      return url && url.substring(2)
    },

    lastMigratedPub: () => store.state.lastMigratedPub,

    autoRepublish () { return this.details.auto_republication },

    user: () => store.state.user
  }
}



// WEBPACK FOOTER //
// ./src/components/publication/CardImpl.js